import { Component, HostListener, OnInit } from '@angular/core';
import { BenefitsPlusService } from '../../services/benefits-plus.service';
import { IBenefitsPlusLobbyResult } from '../../models/lobby-result';
import { IBenefitPlusResult } from '../../models/benefit-plus-result';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { IModalConfig } from '../../../../shared/modules/bs-modal/interfaces/modal-config.interface';
import { BenefitsPopUpComponent } from '../benefits-pop-up/benefits-pop-up.component';
import { ModalService } from '../../../../shared/modules/bs-modal/services/modal.service';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { ActivatedRoute } from '@angular/router';
import { AppConfigsService } from '../../../../config/app-configs.service';



@Component({
    selector: 'app-lobby',
    templateUrl: './lobby.component.html',
    styleUrls: ['./lobby.component.scss']
})
export class LobbyComponent implements OnInit {
    allBenefits: IBenefitPlusResult[] = [];
    promotedBenefits: IBenefitPlusResult[] = [];
    isMobile: boolean;
    isShowMore: boolean;
    page: number = 0;
    data: IBenefitsPlusLobbyResult;
    isLoading: boolean;
    showPromoted: boolean = true;
    total: number = 0;
    lastScrollRatio: number = 0;
    loadLobbyTemplate: boolean = false;
    benefitsLink: string;

    constructor(public benefitsSvc: BenefitsPlusService,
        private uiHelperService: UiHelperService,
        private modalSvc: ModalService,
        private activatedRoute: ActivatedRoute,
        private appConfigsService: AppConfigsService,
        public gtmService: GtmService) {}

    @HostListener('window:scroll', ['$event']) // for window scroll events
    onScroll(event) {
        let pos = event.target.scrollingElement.clientHeight + event.target.scrollingElement.scrollTop;
        let max = event.target.scrollingElement.scrollHeight;
        let ratio = pos / max * 100 | 0;
        if (ratio !== this.lastScrollRatio && [25, 50, 75, 100].includes(ratio)) {
            this.gtmService.pushNewBenefitPulsePageLobby('Scroll - ' + ratio);
            this.lastScrollRatio = ratio;
        }
    }

    ngOnInit(): void {
        this.isMobile = this.uiHelperService.IsMobile();
        this.benefitsSvc.type = null;
        this.benefitsSvc.region = null;
        this.benefitsSvc.sort = null;
        let typeUrl = this.activatedRoute.snapshot.queryParams["type"];
        let filter = null;
        if (typeUrl) {
            filter = {type: {typeUrlName: typeUrl}};
            this.showPromoted = false;
            this.loadLobbyTemplate = true;
        }
        //todo: change to new benefits page when ready.
        this.benefitsLink = `${this.appConfigsService.appConfigs.contentRoot}/he-il/Benefits/Pages/BenfitsGallery.aspx?sourceGA=HomepageBenefitsMarketing`;
        this.loadBenefits(filter);
        this.gtmService.pushNewBenefitPulsePageLobby('load');
    }

    loadBenefits(filters: any = null) {
        if (!this.isLoading) {
            this.isLoading = true;
            this.benefitsSvc.getAllBenefits(this.isMobile, this.page, this.loadLobbyTemplate, filters?.type, filters?.region, filters?.sort).subscribe(res => {
                if (res.returnCode == 0) {
                    if (this.page == 0 && !filters?.type && !filters?.region) {
                        this.data = res.result;
                        this.promotedBenefits = res.result.promotedDiscounts;
                    }
                    else if (this.page == 0 && this.loadLobbyTemplate && filters.type.typeUrlName) {
                        this.data = res.result;
                        this.benefitsSvc.type = this.data.types.filter(t => t.typeUrlName == filters.type.typeUrlName)[0];
                        this.loadLobbyTemplate = false;
                    }

                    if (this.page == 0) {
                        this.allBenefits = res.result.discounts;
                    }
                    else {
                        this.allBenefits = this.allBenefits.concat(res.result.discounts);
                        this.moveFocusToFirstDiscount(res.result.discounts)
                    }
                    this.page++;
                    this.isShowMore = !res.result.isLast;
                    this.total = res.result.totalDiscounts;
                    this.isLoading = false;
                }
            });
        }
    }

    openBenefit(benefit: IBenefitPlusResult) {
        let popup: IModalConfig = {
            content: BenefitsPopUpComponent,
            options: {
                initialState: {
                    data: {
                        showCloseButton: true,
                        closeOnAction: true,
                        benefitName: benefit?.name,
                        categoryName: benefit?.type?.typeUrlName
                    },
                    benefit: benefit
                } as Object
            },
            type: "Popup"
        };
        this.gtmService.pushNewBenefitPulsePageLobby('Click on benefit – ' + benefit?.name);

        this.modalSvc.openModal(popup).subscribe();

        document.querySelector('modal-container').classList
            .add('pop-up-general', 'benefits-plus-popup');
    }

    loadFromFilters(filters: any) {
        if (filters?.type || filters?.region) {
            this.gtmService.pushNewBenefitPulsePageLobby('Use filter');
            this.showPromoted = false;
        }
        else {
            this.showPromoted = true;
            this.promotedBenefits = [];
        }
        this.page = 0;
        this.loadLobbyTemplate = false;
        this.loadBenefits(filters);
    }

    resetFilters() {
        this.benefitsSvc.sort = null;
        this.benefitsSvc.type = null;
        this.benefitsSvc.region = null;
        this.loadFromFilters(null);
    }

    moveFocusToFirstDiscount(newBenefits: IBenefitPlusResult[]) {
        const firstNewDiscountIndex = this.allBenefits.length - newBenefits.length;
        const title = this.allBenefits[firstNewDiscountIndex].title
        const headingsSelector = 'app-all-benefits .discount h1'
        if (title) {
            setTimeout(() => {
                const firstNewDiscountElement = Array.from(document.querySelectorAll(headingsSelector)).find((el) => el.textContent?.includes(title))
                if (firstNewDiscountElement) {
                    firstNewDiscountElement.setAttribute("u1-focus-to", "")

                }
            }, 1000);
        }

    }
}
